import {
  Tooltip as PrimeTooltip,
  TooltipProps as PrimeTooltipProps,
} from 'primereact/tooltip';
import cn from 'classnames';

import classes from './tooltip.module.scss';

type TooltipProps = PrimeTooltipProps & {
  children: string;
  rootClassName?: string;
};

const Tooltip = (props: TooltipProps): JSX.Element => (
  <PrimeTooltip
    className={cn(classes.root, props.rootClassName)}
    content={props.content || props.children}
    {...props}
  />
);

Tooltip.defaultProps = {
  position: 'bottom',
  rootClassName: undefined,
  children: undefined,
  target: undefined,
};

export { Tooltip, TooltipProps };
